import { appQueryClient } from '../../provider'

import type {
  CreateLocationOptions,
  DeleteOneLocationOptions,
  FetchAllLocationsOptions,
  FetchOneLocationOptions
} from './location.api'
import type { LocationUpdateSchema } from './types/Location.update.schema'

export const locationsQueryKeys = {
  checkArchivable: (locationId: string) => ['check_archivable', locationId],
  create: (requestOptions?: CreateLocationOptions) =>
    ['create_location', requestOptions] as const,
  delete: (requestOptions?: DeleteOneLocationOptions) =>
    ['delete_location', requestOptions] as const,
  update: (requestOptions?: LocationUpdateSchema) =>
    ['update_location', requestOptions] as const,
  fetch: {
    all: (queryParams?: Partial<FetchAllLocationsOptions['queryParams']>) =>
      ['fetch_all_locations', queryParams] as const,
    one: (requestOptions: FetchOneLocationOptions) =>
      [
        'fetch_one_location',
        requestOptions.pathParams,
        requestOptions.queryParams || {}
      ] as const
  },
  franchises: {
    all: () => ['franchises']
  }
}

export const invalidateLocationOne = (
  requestOptions: FetchOneLocationOptions
) => {
  appQueryClient.invalidateQueries({
    queryKey: locationsQueryKeys.fetch.one(requestOptions)
  })
}

export const invalidateAllLocations = (
  queryParams?: Partial<FetchAllLocationsOptions['queryParams']>
) => {
  appQueryClient.invalidateQueries({
    queryKey: locationsQueryKeys.fetch.all(queryParams),
    refetchType: 'all',
    exact: false
  })
}
